export const locale = {
  addNewChart: 'Add new chart'
};
